import * as React from 'react';
import axios from "axios";
import hoistoryStore from "../store/historyStore";
import { notifyApiError } from "../utils/apiError";
import { useEffect } from "react";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddTaskIcon from '@mui/icons-material/AddTask';
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from '@mui/material/CircularProgress';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import FlareIcon from '@mui/icons-material/Flare';
import * as util from "../utils/util";
import { Divider } from '@mui/material';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const storeData: any = hoistoryStore();
  const [value, setValue] = React.useState(0);
  const [searchText, setSearchText] = React.useState('');
  const [searchMorningFoodList, setSearchMorningFoodList] = React.useState([]);
  const [searchLunchFoodList, setSearchLunchFoodList] = React.useState([]);
  const [searchDinnerFoodList, setSearchDinnerFoodList] = React.useState([]);
  const [searchSnackFoodList, setSearchSnackFoodList] = React.useState([]);
  const [showLoading, setShowLoading] = React.useState(false);

  // 아침/점심/저녁/간식 탭 이동
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSearchText('');
    setValue(newValue);
    setSearchMorningFoodList([]);
    setSearchLunchFoodList([]);
    setSearchDinnerFoodList([]);
    setSearchSnackFoodList([]);
  };

  // 음식 검색
  function handleSearchFood() {
    if (searchText !== '') {
      setShowLoading(true);
      // timeout 을 주지 않으면 axios 기본값이 '무제한'이라, 응답이 끊긴 회선에서
      // 검색 스피너가 영영 돈다. 외부(공공데이터포털) API 라 여유 있게 잡는다.
      axios.get(`https://apis.data.go.kr/1471000/FoodNtrCpntDbInfo02/getFoodNtrCpntDbInq02?serviceKey=GBip9SFeHYDRC3h2%2FA3COqWQGGco1Ixbwiz8pl1jM7kS77d%2BbQfbgfOEZvSlY639upCrV6DyCHncxeho9mBAiQ%3D%3D&FOOD_NM_KR=${encodeURIComponent(searchText)}&type=json&numOfRows=100`, { timeout: 20000 }).then(res => {
        if (Number(res.data.body.totalCount) > 0) {
          if (value === 0) setSearchMorningFoodList(res.data.body.items);
          if (value === 1) setSearchLunchFoodList(res.data.body.items);
          if (value === 2) setSearchDinnerFoodList(res.data.body.items);
          if (value === 3) setSearchSnackFoodList(res.data.body.items);
        }else{
          if (value === 0) setSearchMorningFoodList([]);
          if (value === 1) setSearchLunchFoodList([]);
          if (value === 2) setSearchDinnerFoodList([]);
          if (value === 3) setSearchSnackFoodList([]);
        }
      }).catch(function (error) {
        // 사용자가 직접 누른 검색이라 결과가 왜 안 나오는지 알려준다
        notifyApiError(error, '음식을 검색하지 못했습니다.');
      }).finally(function () {
        // 실패해도 스피너는 반드시 걷는다
        setShowLoading(false);
      });
    } else {
      alert('음식명을 입력하세요');
    }
  }

  // 검색한 음식 목록 중 음식 선택
  function handleSelectFood(div: any, index: any) {
    let selectedFoodInfo = { FOOD_NM_KR: '', AMT_NUM1: '' };
    if (div === 'morning') selectedFoodInfo = searchMorningFoodList[index];
    else if (div === 'lunch') selectedFoodInfo = searchLunchFoodList[index];
    else if (div === 'dinner') selectedFoodInfo = searchDinnerFoodList[index];
    else if (div === 'snack') selectedFoodInfo = searchSnackFoodList[index];
    let food = { gubun: div || '', name: selectedFoodInfo['FOOD_NM_KR'] || '', calory: Number(selectedFoodInfo['AMT_NUM1']), amount: 0.5 };
    let foodArr = [];
    if (storeData.selectedFoodList.some((item: any) => item.gubun === div && item.name === selectedFoodInfo['FOOD_NM_KR'])) {  // 이미 선택된 음식
      foodArr = storeData.selectedFoodList.map((v: any) => v.gubun === div && v.name === selectedFoodInfo['FOOD_NM_KR'] ? { ...v, amount: v.amount + 0.5 } : v);
    } else {  // 처음 선택된 음식
      foodArr = storeData.selectedFoodList.concat(food);
    }

    // 사용자가 추가한 음식이 최상단에 위차하여 사용자가 확인할 수 있도록 순서 변경
    const newFoodArr = [
      ...foodArr.filter((v: any) => v.gubun === div && v.name === selectedFoodInfo['FOOD_NM_KR']),
      ...foodArr.filter((v: any) => !(v.gubun === div && v.name === selectedFoodInfo['FOOD_NM_KR']))
    ];

    storeData.setSelectedFoodList(newFoodArr);
  }

  // 선택한 음식 목록 중 음식 선택 해제
  function handleUnselectFood(gubun: any, name: any) {
    let foodArr = [];
    if (storeData.selectedFoodList.some((item: any) => item.gubun === gubun && item.name === name && item.amount > 0.5)) {  // 해제한 음식의 카운트가 2 이상일 때 => 푸드 객체 count - 1
      foodArr = storeData.selectedFoodList.map((v: any) => v.gubun === gubun && v.name === name ? { ...v, amount: v.amount - 0.5 } : v);
    } else {  // 해제한 음식의 카운트가 1 일 때 => 배열에서 푸드 객체 삭제
      foodArr = storeData.selectedFoodList.filter((v: any) => !(v.gubun === gubun && v.name === name));
    }
    storeData.setSelectedFoodList(foodArr);
  }

  // 선택한 음식 목록 중 음식칼로리 추가
  function handleAddselectFood(gubun: any, name: any) {
    let foodArr = [];
    if (storeData.selectedFoodList.some((item: any) => item.gubun === gubun && item.name)) {
      foodArr = storeData.selectedFoodList.map((v: any) => v.gubun === gubun && v.name === name ? { ...v, amount: v.amount + 0.5 } : v);
    }
    storeData.setSelectedFoodList(foodArr);
  }

  function getKorGubun(gubun: any) {
    switch (gubun) {
      case 'morning': return <div className="morning" style={{ color: '#ef8322' }}><WbTwilightIcon /><br />아침</div>;
      case 'lunch': return <div className="lunch" style={{ color: '#fd5c5c' }}><LightModeIcon /><br />점심</div>;
      case 'dinner': return <div className="dinner" style={{ color: '#ffb70d' }}><BedtimeIcon /><br />저녁</div>;
      case 'snack': return <div className="snack" style={{ color: '#aa1eff' }}><FlareIcon /><br />간식</div>;
      default: return '';
    }
  }



  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="food tabs" textColor="secondary" indicatorColor="secondary">
          <Tab label="아침" {...a11yProps(0)} sx={{ minWidth: 70 }} />
          <Tab label="점심" {...a11yProps(1)} sx={{ minWidth: 70 }} />
          <Tab label="저녁" {...a11yProps(2)} sx={{ minWidth: 70 }} />
          <Tab label="간식" {...a11yProps(3)} sx={{ minWidth: 70 }} />
        </Tabs>
      </Box>

      <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#f5f5f5', pt: 0.5, pb: 0.5, pr: 1 }}>
        <InputBase
          sx={search_Fome_Style}
          placeholder="음식명을 입력하세요"
          inputProps={{ 'aria-label': '음식명을 입력하세요' }}
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          type="search"
        />
        <Box sx={{ width: '30%', bgcolor: '#EF8322', color: '#fff', borderRadius: 5, textAlign: 'center', py: .5, boxSizing: 'border-box' }} aria-label="search" onClick={handleSearchFood}>
          <SearchIcon sx={{ verticalAlign: 'middle', }} /> <Typography component={'span'} sx={{ fontSize: 15 }}>검색</Typography>
        </Box>
      </Stack>




      <CustomTabPanel value={value} index={0} >
        <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 250, overflow: 'auto', p: 1 }}>
          {!showLoading && searchMorningFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 2, color: '#EF8322', fontWeight: 700 }}>음식이 없습니다.</Typography>
          ) : (
            searchMorningFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 1, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('morning', index)}
                  secondaryAction={
                    <IconButton aria-label="add" edge="end" onClick={() => handleSelectFood('morning', index)} sx={{ p: 0 }}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{food.FOOD_NM_KR}
                      <Typography component={'span'} sx={{ fontSize: 14, ml: 1 }}>{util.formatComma(food.AMT_NUM1) + ' kcal'}</Typography>
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 250, overflow: 'auto', p: 1 }}>
          {!showLoading && searchLunchFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 2, color: '#EF8322', fontWeight: 700 }}>음식이 없습니다.</Typography>
          ) : (
            searchLunchFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 1, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('lunch', index)}
                  secondaryAction={
                    <IconButton aria-label="add" edge="end" onClick={() => handleSelectFood('lunch', index)} sx={{ p: 0 }}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, pr: 6 }}>{food.FOOD_NM_KR}
                      <Typography component={'span'} sx={{ fontSize: 14, ml: 1 }}>{util.formatComma(food.AMT_NUM1) + ' kcal'}</Typography>
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 250, overflow: 'auto', p: 1 }}>
          {!showLoading && searchDinnerFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 2, color: '#EF8322', fontWeight: 700 }}>음식이 없습니다.</Typography>
          ) : (
            searchDinnerFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 1, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('dinner', index)}
                  secondaryAction={
                    <IconButton aria-label="add" edge="end" onClick={() => handleSelectFood('dinner', index)} sx={{ p: 0 }}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{food.FOOD_NM_KR}
                      <Typography component={'span'} sx={{ fontSize: 14, ml: 1 }}>{util.formatComma(food.AMT_NUM1) + ' kcal'}</Typography>
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 250, overflow: 'auto', p: 1 }}>
          {!showLoading && searchSnackFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 2, color: '#EF8322', fontWeight: 700 }}>음식이 없습니다.</Typography>
          ) : (
            searchSnackFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 1, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('snack', index)}
                  secondaryAction={
                    <IconButton aria-label="add" edge="end" onClick={() => handleSelectFood('snack', index)} sx={{ p: 0 }}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, }}>{food.FOOD_NM_KR}
                      <Typography component={'span'} sx={{ fontSize: 14, ml: 1 }}>{util.formatComma(food.AMT_NUM1) + ' kcal'}</Typography>
                    </Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <Box sx={{
        maxHeight: 300, overflow: 'auto', bgcolor: '#fff0e1', borderRadius: '0 0 15px 15px', p: 1,
        '& .mealList:last-child': { borderRadius: '0 0 15px 15px' }
      }}>
        {storeData.selectedFoodList.filter((item: any) => item.name !== '').map((food: any, index: any) => (
          <Box className='mealList' sx={{ p: 1, pt: 0.5, pb: 0.5 }}>
            <Stack direction='row' justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#fff', borderRadius: 2, p: 1, border: '1px solid #ef9f58' }}>
              <Typography component={'div'} sx={{ fontSize: 14, fontWeight: 700, width: '12%', textAlign: 'center' }}>
                {getKorGubun(food.gubun)}
              </Typography>
              <Typography component={'div'} sx={{ fontSize: 14, width: '40%', textAlign: 'center' }}>
                {food.name}<br />
                <span style={{ fontWeight: 700 }}>{food.calory}</span> kcal
              </Typography>
              <Typography component={'div'} sx={{ fontSize: 14, width: '28%', mr: 1, textAlign: 'center' }}>
                {food.amount}인분<br />
                <span style={{ fontWeight: 700 }}>{util.formatComma((food.calory * food.amount).toFixed(2))}</span> kcal
              </Typography>

              <IconButton aria-label="add" onClick={() => handleAddselectFood(food.gubun, food.name)} sx={{ width: '9%', mr: 1.5 }}>
                <AddCircleOutlineIcon sx={{ color: '#5d86ff', fontSize: 30 }} />
              </IconButton>
              <IconButton aria-label="remove" onClick={() => handleUnselectFood(food.gubun, food.name)} sx={{ width: '9%' }}>
                <RemoveCircleOutlineIcon sx={{ color: '#f54d4d', fontSize: 30 }} />
              </IconButton>
            </Stack>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

const search_Fome_Style = {
  px: 2,
  py: .5,
  m: 1,
  bgcolor: '#fff',
  borderRadius: '24px',
  boxShadow: 'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing: 'border-box'
};